export var APPOINTMENT_DETAILS_VIEWED = 'appointment_details_viewed';
export var BLOCK_TIME_CREATED = 'block_time_created';
export var APPOINTMENT_BOOKED = 'appointment_booked';
export var APPOINTMENT_MODIFIED = 'appointment_modified';
export var APPOINTMENT_CANCELLED = 'appointment_cancelled';
export var APPOINTMENT_CHARGED = 'appointment_charged';
export var CHARGE_REFUNDED = 'charge_refunded';
export var USER_SIGNED_IN = 'user_signed_in';
// AI Hack Week Reporting Bot events
export var REPORTING_BOT_MODAL_OPENED = 'reporting_bot_modal_opened';
export var REPORTING_BOT_SUGGESTION_CLICKED = 'reporting_bot_suggestion_clicked';
export var REPORTING_BOT_CUSTOM_QUERY_ENTERED = 'reporting_bot_custom_query_entered';
export var REPORTING_BOT_HISTORY_VIEWED = 'reporting_bot_history_viewed';
export var REPORTING_BOT_HISTORY_CONVERSATION_CLICKED = 'reporting_bot_history_conversation_clicked';
export var REPORTING_BOT_QUERY_INTERRUPTED = 'reporting_bot_query_interrupted';
